import { ICollectionStateHook } from '@broadleaf/admin-components/dist/types/collection';
import { selectAllSelectedItems } from '@broadleaf/admin-components/dist/collection/hooks/useCollectionState';
import { useFormatNumber } from '@broadleaf/admin-components/dist/common';
import { MessageDescriptor } from 'react-intl';
import useFormatMessage from '@broadleaf/admin-components/dist/common/hooks/useFormatMessage';
import { useMemo } from 'react';

/** Returns a label for the grid with the currecnt selected number and invoice balance total */
export const useLabelWithTotals = (
  collectionState: ICollectionStateHook,
  label: MessageDescriptor
) => {
  const formatMessage = useFormatMessage();
  const formatNumber = useFormatNumber();
  const allSelectedItems = useMemo(() => {
    return selectAllSelectedItems(collectionState.state) as any;
  }, [collectionState.state]);

  return (
    <>
      {formatMessage(label)}
      <div className="tw-mt-1 tw-text-xs tw-font-bold">
        <span>{`${allSelectedItems.length} Selected`}</span>
        <span className="tw-ml-2">
          Total Invoice Balance{' '}
          {formatNumber(
            allSelectedItems.reduce(
              (acc, item) => acc + item.invoiceBalance.amount,
              0
            ),
            {
              style: 'currency',
              currency: allSelectedItems[0]?.invoiceBalance.currency || 'USD'
            }
          )}
        </span>
      </div>
    </>
  );
};
